import React, { useState } from 'react'
import styled from '@emotion/styled'
import request from 'Root/request'
import { navigate } from 'raviger'

import AuthCard from './Card'
import { Input } from 'Components/Input'
import Button from 'Components/Button'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSpinner } from '@fortawesome/free-solid-svg-icons'

const ErrorMessage = styled.span`
  color: #f00;
`

export default () => {
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()

  const login = async () => {
    if (isLoading) return
    setIsLoading(true)
    const params = new URLSearchParams({ username, password })
    try {
      await request.get('/auth/login', { params })
      navigate('/')
    } catch (err) {
      setError(err.response.data.message)
    }
    setIsLoading(false)
  }

  return (
    <AuthCard>
      <h1 style={{ fontSize: '1.5em' }}>CAREMINDr Reporting Portal</h1>
      {error && <ErrorMessage>{error}</ErrorMessage>}
      <Input
        placeholder="Username"
        onChange={e => setUsername(e.target.value)}
        value={username}
      />
      <Input
        placeholder="Password"
        type="password"
        onChange={e => setPassword(e.target.value)}
        value={password}
      />
      <Button onClick={login}>
        {isLoading ? (
          <FontAwesomeIcon icon={faSpinner} spin size="lg" />
        ) : (
          'Login'
        )}
      </Button>
    </AuthCard>
  )
}
